var interopRequireDefault = {exports: {}};

export { interopRequireDefault as __module };
